import React from "react";
import printerSvg from "../../../../assets/images/printer.svg";
import mailSvg from "../../../../assets/images/mail.svg";
import { GiCancel } from "react-icons/gi";

import moment from "moment";
import ColumnTableComment from "./ServiceForms/ColumnTableComment";
import { exportDocument, returnEuroString } from "../../../helpers/Utils";
import { EditElementClick, LongButton } from "../../common/Buttons";
import {
  status_options,
  shipment_types_options,
} from "../../../helpers/GlobalOptions";
import SupplyingTableIndex from "../../orders/accepted_orders/items/SupplyingTableIndex";
import { AiOutlineCheckCircle, AiOutlineFilePdf } from "react-icons/ai";
import ClientInfoComponent from "../../Repetitive_components/clientInfoComponent";
import CourierLinksComponent from "../../Repetitive_components/courierLinksComponent";
import ServiceRowChangesTable from "./ServiceForms/service_row_changes_table";
import { FaTimes } from "react-icons/fa";
import { Tooltip } from "antd";
import { supplyingCount } from "../../../helpers/OrdersFunctionsGlobal";
import { colors } from "../../../utils/colors";

function TableColumnService({ item, index, openModal }) {
  const findStatusName = () => {
    const find_status = status_options.find((e) => e.value == item.status);
    if (!find_status) return item.status;

    return (
      <LongButton
        style={{
          backgroundColor: find_status.color || colors['purple'],
          color: "white",
          fontSize: "12px",
          height: "auto",
        }}
        text={find_status.label || ""}
      />
    );
  };

  const renameShipmentName = (name) => {
    const findShipment = shipment_types_options.find((e) => e.value === name);
    if (findShipment) {
      return findShipment.label;
    } else {
      return "";
    }
  };


  return (
    <tr className="align-middle tableColumn" key={index}>
      <td className="align-middle">
        <span className="date-field">
          {moment(item.created_at).format("YYYY MM DD")}
        </span>
        <br />
        <span className="date-field">
          {moment(item.created_at).format("HH:mm")}
        </span>
      </td>
      <td className="align-middle">
        <EditElementClick
          id={item.number}
          name={item.number}
          onEdit={() =>
            openModal("modal", { id: item.id, number: item.number })
          }
        />
      </td>
      <td className="align-middle">
        {item.order ? (
          <div
            className="text-orange cursor-pointer"
            onMouseUp={() => {
              window.open(`/orders/${item.order.id}`, "_blank");
              window.focus();
            }}
          >
            {item.order.id_order}
          </div>
        ) : (
          ""
        )}
      </td>
      <td className="align-middle">{item.service_type}</td>
      <td className="align-middle">
        {item.address && <ClientInfoComponent client={item.address} />}
      </td>
      <td className="align-middle">
        {item.service_rows &&
          item.service_rows.map((e, index) => {
            const supplying_count = supplyingCount(e.supplyings);

            return (
              <React.Fragment key={index}>
                {!e.manual && item.refuses_to_repair && (
                  <Tooltip placement="top" title="Refuses to repair">
                    <GiCancel className="text-danger mr-2" />
                  </Tooltip>
                )}
                <span>
                  <span
                    className={
                      supplying_count > 0 ? "text-success" : "text-danger"
                    }
                  >
                    [SU:{supplying_count}]
                  </span>
                  <span>
                    {e.shipments_count > 0 ? (
                      <span className="text-success">
                        [S:{e.shipments_count}]
                      </span>
                    ) : (
                      <span className="text-danger">
                        [S:{e.shipments_count}]
                      </span>
                    )}
                  </span>
                  {parseInt(e.item_quantity || 0)}
                  &nbsp;*&nbsp;
                  {["{}", ""].includes(e.item_code) ? (
                    <AiOutlineCheckCircle className="text-success mr-1" />
                  ) : (
                    e.item_code
                  )}
                  &nbsp;
                  <span
                    className={
                      e.manual ? "border-bottom border-danger d-flex" : "d-flex"
                    }
                  >
                    <span className="mr-2">{e.item_name}</span>
                    {!e.manual && (
                      <span>
                        <Tooltip
                          placement="top"
                          title={"Export warranty registration"}
                        >
                          <span
                            className="btn-primary d-flex justify-content-center align-items-center cursor-pointer"
                            style={{
                              width: 29,
                              height: 29,
                              borderRadius: "50%",
                            }}
                            onClick={() =>
                              exportDocument(
                                `/api/v1/repair_services/${item.id}/export_warranty_registration/`,
                                `export_warranty_registration.pdf`,
                                "POST"
                              )
                            }
                          >
                            <AiOutlineFilePdf
                              style={{ width: 13, height: 13 }}
                            />
                          </span>
                        </Tooltip>
                      </span>
                    )}
                  </span>
                </span>

                <table>
                  <tbody style={{ fontWeight: "400" }}>
                    {e.supplyings &&
                      e.supplyings.map((itemSup, i) => (
                        <SupplyingTableIndex
                          key={i}
                          item={itemSup}
                          product_reference={e.item_code}
                          id_order_row={e.id}
                        />
                      ))}
                    {e.service_row_changes &&
                      e.service_row_changes.map((itemSup, i) => (
                        <ServiceRowChangesTable key={i} item={itemSup} />
                      ))}
                  </tbody>
                </table>
                <div className="my-1" />
              </React.Fragment>
            );
          })}
      </td>
      <td className="align-middle">
        {item.service_number || <FaTimes className="text-danger" size={18} />}
      </td>
      <td className="align-middle">
        <CourierLinksComponent shipments={item.shipments} />
      </td>
      <td className="align-middle">
        {item.shipments &&
          item.shipments.map((e) => (
            <div key={e.id}>{renameShipmentName(e.shipment_type)}</div>
          ))}
      </td>
      <td className="align-middle">{findStatusName()}</td>
      <ColumnTableComment comments={item.service_comments} type="comment_ka" />
      <ColumnTableComment
        comments={item.service_comments}
        type="comment_logistic"
      />
      <ColumnTableComment
        comments={item.service_comments}
        type="comment_service"
      />
      <td className="align-middle">{returnEuroString(item.total_price)}</td>
      <td className="align-middle">
        <button
          className="btn btn-sm mr-1 mb-1"
          style={{ background: "#8678ab" }}
          onClick={() =>
            openModal("email", {
              id: item.id,
              number: item.number,
              email: item.address.other,
            })
          }
        >
          <img
            style={{ color: "white" }}
            width="11.12"
            height="11.12"
            src={mailSvg}
          />
        </button>
        <button
          className="btn btn-sm mb-1"
          style={{ background: "#ef3824" }}
          onClick={() =>
            exportDocument(
              `/api/v1/repair_services/download/${item.id}`,
              `${item.number}.pdf`
            )
          }
        >
          <img
            style={{ color: "white" }}
            width="11.12"
            height="11.12"
            src={printerSvg}
          />
        </button>
      </td>
    </tr>
  );
}

export default TableColumnService;
